import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { ThemeSimpleFormContent } from "./components/ThemeSimpleFormContent";

export function ThemeCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <ThemeSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
